module.exports = __webpack_public_path__ + "static/media/NPFDA Logo.744ebbb6.png";